import React from "react";
import { Alert, Button, Empty, Table } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import useDetailTableHeight from "./useDetailTableHeight";

const money = (value) => value == null ? "—" : Number(value).toLocaleString("en-US", { style: "currency", currency: "USD" });

export default function RentDetails({ rows, error, onRetry, amount }) {
  const [tableHost, tableHeight] = useDetailTableHeight(rows, error);
  return <section className="notice-detail-panel notice-rent-panel" aria-label="Rent outstanding details">
    <header className="notice-panel-header">
      <div className="notice-panel-heading">
        <div className="notice-panel-title"><h3>Rent outstanding details</h3>
          <span>{rows ? `${rows.length} allocation item${rows.length === 1 ? "" : "s"}` : error ? "Details unavailable" : "Loading details…"}</span></div>
        <p>Payments and adjustments settle their own month first. Remaining credits then offset the oldest unpaid months.</p>
      </div>
      <div className="notice-detail-balance">
        <span className="notice-detail-label">Rent outstanding</span><strong>{amount}</strong>
      </div>
    </header>
    {error ? <Alert showIcon type="error" message={error}
      action={<Button size="small" icon={<ReloadOutlined />} aria-label="Retry rent details" onClick={onRetry}>Retry</Button>} /> :
      <div className="notice-detail-table-host" ref={tableHost}>
        <Table rowClassName="table-row-gradient" className="notice-detail-table notice-rent-table" size="small" pagination={false} loading={!rows} dataSource={rows || []}
          scroll={{ x: 620, y: tableHeight }}
          locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No outstanding rent items" /> }}
          rowKey={(row) => `${row.tenantId}-${row.itemType}-${row.invoiceDate ?? "balance"}-${row.cntlNo ?? "month"}`}
          columns={[
            { title: "Rent date", dataIndex: "invoiceDate", width: 100, render: (value) => value || "—" },
            { title: "Invoice / item", dataIndex: "cntlNo", width: 160, render: (value, row) => value ?? row.description },
            { title: "Charges", dataIndex: "charges", width: 110, align: "right", render: money },
            { title: "Credits / offsets", dataIndex: "credits", width: 120, align: "right", render: money },
            { title: "Rent outstanding", dataIndex: "amount", width: 130, align: "right", fixed: "right",
              render: (value) => <strong className="notice-detail-amount">{money(value)}</strong> },
          ]} />
      </div>}
  </section>;
}
